import { m } from "@plannello/i18n/messages";
import { ApiError } from "@/lib/api";

/**
 * One place that turns the admin API's error codes into sentences a person can act on. Unknown
 * failures fall back to the generic network or "something went wrong" copy.
 */
export function adminError(e: unknown): string {
  if (!(e instanceof ApiError)) return m.error_generic();
  if (e.isNetwork || e.status === 502 || e.status === 503 || e.status === 504) return m.error_network();
  switch (e.code) {
    case "owner_only":
      return m.adm_err_owner_only();
    case "last_owner":
      return m.adm_err_last_owner();
    case "cannot_disable_self":
      return m.adm_err_cannot_disable_self();
    case "human_required":
      return m.adm_err_human_required();
    case "user_disabled":
      return m.adm_err_user_disabled();
    case "email_taken":
      return m.adm_err_email_taken();
    case "membership_managed_by_oidc":
      return m.adm_err_managed_by_oidc();
    case "already_member":
      return m.adm_err_already_member();
    case "external_id_taken":
      return m.adm_err_external_id_taken();
    case "builtin_role":
      return m.adm_err_builtin_role();
    case "role_in_use":
      return m.adm_err_role_in_use();
    case "slug_taken":
      return m.adm_err_slug_taken();
    case "already_assigned":
      return m.adm_err_already_assigned();
    case "role_not_assignable":
      return m.adm_err_role_not_assignable();
    case "role_exceeds_own_permissions":
      return m.adm_err_exceeds();
    case "session_required":
      return m.adm_err_session_required();
    case "invite_closed":
      return m.adm_err_invite_closed();
    case "import_running":
      return m.adm_gh_err_running();
    case "github_token_missing":
      return m.adm_gh_err_token();
    case "not_found":
      return m.adm_err_not_found();
    case "rate_limited":
      return m.error_rate_limited();
    case "forbidden":
      return m.adm_err_forbidden();
    default:
      return e.status === 403 ? m.adm_err_forbidden() : m.error_generic();
  }
}

/** True for 403/forbidden: the page can show the permission-denied state instead of a retry. */
export function isForbidden(e: unknown): boolean {
  return e instanceof ApiError && e.status === 403;
}
